import { render, staticRenderFns } from "./MainSlider.vue?vue&type=template&id=219ef664&scoped=true&"
import script from "./MainSlider.vue?vue&type=script&lang=js&"
export * from "./MainSlider.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./MainSlider.vue?vue&type=style&index=0&id=219ef664&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "219ef664",
  null
  ,true
)

export default component.exports